<template>
 <div class="root">
   <img class="bgImage" src="../../assets/images/WaterSign_bg.jpg"/>
   <img class="logoImage" src="../../assets/images/WaterSign_logo.png" />
   <div class="viewBg"  >
      <!-- <img class="bg_image" src="../../assets/images/WaterSign_bg.jpg" /> -->
      <div :class="['mianview',isfocus==1?'onfocus':'']">
          <span class="mianview_title">会议室编号</span>
          <div class="mianview_div">
              <div class="mianview_div_left">
                <input class="input" type="text" placeholder="请输入" @focus="focus"  @blur="blur" v-model.trim="meettingID" />
              </div>
              <span class="mianview_div_right" @click="getMeetingOrderlistByRoomNo()">确认</span>
          </div>
      </div>
    </div>
 </div>
</template>

<script>
import {getMeetingOrderListByRoomNo} from "../../utils/api";
import storage from '../../utils/storage';
import util from "../../utils/util";
export default {
    name:'WaterSignIndex',
    data(){
      return {
        isfocus:0,
        bg_image:require("../../assets/images/WaterSign_bg.jpg"),
        meettingID:'',
      }
    },
    created(){
        this.meettingID = storage.get('meettingID') || '';
    },
    methods: {
         focus(e){
             console.log("in focus")
             this.isfocus=1;
         },
         blur(e){
             this.isfocus=0;
         },
         getMeetingOrderlistByRoomNo(){
            if(!this.meettingID){
                return;
            }
            let params = {
              'roomNo': this.meettingID
            }
            this.allPayAmount =0;
            this.isChouse=false;
            getMeetingOrderListByRoomNo(params).then(res => {
                this.timestamp =res.res.timestamp;
                if (res.res.code === 10000 && res.body) {
                    //var list = res.body.meetingOrderList;
                    storage.set('meettingID', this.meettingID)
                    this.pushToMian()
                }else{
                    util.showToast(res.res.msg);
                }
            });

        },

        pushToMian(){
            var url ='/WaterSignMian?meettingID='+this.meettingID;
            this.$router.push(url);
        }
    } ,
}
</script>
<style lang="less" scoped>
.root{
    width: 100%;
   height: 100%;
   position: relative;
}
.bgImage{
    width: 100%;
    height: 100%;
    z-index: 1;
    position:absolute;
}
.logoImage{
     top: 6.25vh;
     left: 6.26vh;
     width: 25vh;
     height: 3.375vh;
     z-index: 1;
    position:absolute;
}
.viewBg{
   width: 100%;
   height: 100%;
   z-index: 11;
   position:absolute;
   flex-direction: column;

}
.mianview{
    margin-top:33.75vh ;
    margin-left:27.7vw;
    width: 44.5vw;
    height: 32.5vh;
    flex-direction: column;
    display: flex;
    // background-color: red;
}
.mianview_title{
    font-size:4.5vh;
    font-weight:500;
    color:rgba(255,255,255,1);
    line-height:6vh;
}
.mianview_div{
    margin-top: 4.5vh;
    flex-direction:row;
    width: 44.5vw;
    display: flex;
    justify-content: space-between;
}

.mianview_div_left{
    width:31.25vw;
    height:10vh;
    // background:rgba(255,255,255,0.1);
    border-radius:12px;
    border:1px solid rgba(255,255,255,1);


}
.input{
    height: 10vh;
    width:95%;
    padding-left: 20px;
    padding-right: 20px;
    background:rgba(255,255,255,0.01);
    font-size:4.5vh;
    font-weight:400;
    color:rgba(255,255,255,1);
    line-height:10vh;
}
.onfocus{
     margin-top:23.75vh ;
  // margin-bottom:10vh;
}
.mianview_div_right{
    width:11.72vw;
    height:10vh;
    background:rgba(80,95,255,1);
    border-radius:12px;
    text-align: center;;
    font-size:4.5vh;
    font-weight:400;
    color:rgba(255,255,255,1);
    line-height:10vh;
}


</style>